import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from '../Routes/HomePage';
import SubscriptionPage from '../Routes/SubscriptionPage';
import RedirectPage from '../Routes/RedirectPage';
import LoginPage from '../Routes/LoginPage';

const Routing = () => {
    const router = createBrowserRouter([
    {
      path: "/home",
      element: <HomePage />,
    },
    {
      path:"/",
      element:<SubscriptionPage />
    },
    {
      path:"/redirect",
      element:<RedirectPage />
    },
    {
      path:"/login",
      element:<LoginPage />
    }
  ]);
  return (
    <RouterProvider router={router} />
  )
}

export default Routing